import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function ArticleHighlights() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              影视资讯
            </h2>
            <p className="mt-1 text-sm text-foreground-500">最新影视动态、行业深度分析</p>
          </div>
          <Link
            to="/category/dianying"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            更多资讯 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={`${article.title} - 69视频`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 font-heading">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-1"></i>{article.views}</span>
                  <span><i className="ri-user-line mr-1"></i>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}